import FeaturesBonusProgram from '../_raw/features/icon_features_bonus_program.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FeaturesBonusProgram, { shouldSetDefaultSize: false });
